import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatPrice = (price, currency = "TRY") => {
  if (price === null || price === undefined) return "";
  const maxFrac = Math.round(price * 100) % 100 !== 0 ? 2 : 0;
  if (currency === "TRY") {
    const num = new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: maxFrac }).format(price);
    return `${num} TL`;
  }
  return new Intl.NumberFormat("en-US", { style: "currency", currency, minimumFractionDigits: 0, maximumFractionDigits: maxFrac }).format(price);
};

